import React, { FC, useEffect, useRef, useState } from "react";
import Card8 from "components/Card8/Card8";
import HeaderFilter from "./HeaderFilter";
import Card9 from "components/Card9/Card9";
import { BACKEND_URL } from "constants"
import { Link } from "react-router-dom"
import HeaderFilter2 from "./HeaderFilter2"
import CardNewspapper from "components/CardNewspapper/CardNewspapper"
import CardNewspapperOne from "components/CardNewspapperOne/CardNewspapperOne"
import PdfViewer from "app/(archives)/pdfViewer/pdfViewer"

// export interface SectionMagazine4Props extends SectionMagazine1Props {}

const SectionNewspapperPreviewOne = ({
  posts,
  className = "",
  category_id,
  category,
  subcategory_id,
  heading = "Latest Articles 🎈",
}) => {
  const [pdf, setPdf] = useState("")

  // const handleNavigation = () => {

  // }
  return (
      <div className={`nc-SectionMagazine4 ${className}`}>
       <div className="mobile-header"><HeaderFilter2 heading={heading} /></div> 
       <button className="subcategory-btn" style={{color:"white", marginTop:"10px", fontSize:"20px", textAlign:"center", marginBottom:'10px', width:"99%", border:"none", padding:"3px 3px 3px 3px"}}>W najnowszym numerze</button>
  
        {!posts.length && <span>Ładuje artykuły...</span>}
        <div 
        className=""
        >
          {posts
            // .reverse()
            .map((item) => {
            return (
              <div className="newspapper-section" style={{display:"flex", alignItems:"flex-start", width:"100%"}} key={item.id}>
                {/* <span className="category-titles"  style={{color:"red",fontWeight:700}}><b>{item?.title}</b></span> */}
                <CardNewspapperOne key={item.id} post={item} />
                <div className="newspapper-box" style={{display:"flex", gap:"20px"}}>
                <h3 className="newspapper-font">{item?.title_home}</h3>
                <p className="newspappers-text" >{item?.first_description}</p>
                <p className="newspappers-text">
                {item?.second_description}
                </p>
                <h3 style={{ textAlign:"left", fontSize:"18px", lineHeight:'40px'}} className="newspapper-font">Czytaj więcej</h3>
                </div>
                <hr className="mobile-line" style={{padding:"1px", marginTop:"20px", backgroundColor:"#ac8502"}}></hr>
              </div>
            )})}
            {/* {posts[10] && <Card8 category={category} className="sm:col-span-2" post={posts[10]} />} */}
        </div>
      </div>
    );
};

export default SectionNewspapperPreviewOne;
